import React from 'react';
import PropTypes from 'prop-types';

import { Logger } from 'aws-amplify';

import { Redirect } from 'react-router';

import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  FormLabel,
}                     from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';

import {
  Alert,
  AlertTitle,
} from '@material-ui/lab';

import {
  startExecution,
}                     from  '../hooks';

import {
  fmtBigInteger,
}                     from  '../../utils/formatters';

const useStyles = makeStyles((theme) => ({
  root: {
  },
}));

const logger = new Logger('ExecutionActionRepeat');

export default function ExecutionActionRepeat(props) {
  const { execution, open, onClose } = props;

  const [startExecutionStatus, setStartExecutionStatus] = React.useState(null);
  const [startExecutionMessage, setStartExecutionMessage] = React.useState(null);
  const [startedExecutionId, setStartedExecutionId] = React.useState(null);
  const [goToStartedExecution, setGoToStartedExecution] = React.useState(false);

  const [includeResult, setIncludeResult] = React.useState({
    rejected: true,
    skipped: true,
    failed: true,
    succeeded: false,
  });

  const rejected=execution.Inputs.Rejected.Objects;
  const skipped=execution.Inputs.Skipped.Objects;
  const failed=execution.Inputs.Failed.Objects;
  const succeeded=execution.Inputs.Succeeded.Objects;
  
  const filters=Math.min(1,rejected)+Math.min(1,skipped)+Math.min(1,failed)+Math.min(1,succeeded);
  
  const classes = useStyles();

  const handleStartExecution = async () => {
    const includeResultFilters=[];
    if(filters>1) {
      if(rejected && includeResult.rejected) {
        includeResultFilters.push('REJECTED');
      }
      if(skipped && includeResult.skipped) {
        includeResultFilters.push('SKIPPED');
      }
      if(failed && includeResult.failed) {
        includeResultFilters.push('FAILED');
      }
      if(succeeded && includeResult.succeeded) {
        includeResultFilters.push('SUCCEEDED');
      }
    }
    const selector = {
      "Description": `REPEAT: ${includeResultFilters.join(', ')} from ${execution.ExecutionId}`,
      "Inputs": {
        "Execution": execution.ExecutionId,
      }
    };
    if(includeResultFilters) {
      selector['Inputs']['IncludeResult']=includeResultFilters;
    }
    setStartExecutionStatus('STARTING');
    logger.info("SELECTOR: ",selector);
    doStartExecution(execution.WorkloadId, selector);
  };
  
  const handleViewNewExecution = () => {
    setGoToStartedExecution(true);
  };
  
  const handleIncludeResultChange = (event) => {
    setIncludeResult({ ...includeResult, [event.target.name]: event.target.checked });
  };

  const doStartExecution = async (workloadId, selector) => {
    const { succeeded, data, error } = await startExecution(workloadId, selector);
    if(succeeded) {
      setStartExecutionStatus('STARTED');
      setStartedExecutionId(data.ExecutionId);
    } else {
      setStartExecutionStatus('FAILED');
      setStartExecutionMessage(error);
    }
  };
  
  if(startedExecutionId && goToStartedExecution) {
    return <Redirect push to={"/Executions/"+startedExecutionId} />;  
  }

  return(
    <Dialog
      className={classes.root}
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      {startExecutionStatus==='STARTING'?
      <Alert severity="info">
        <AlertTitle>Starting</AlertTitle>
        A new execution is starting... <strong>please wait!</strong>
      </Alert>
      :startExecutionStatus==='STARTED'?
      <Alert severity="success" onClose={onClose}>
        <AlertTitle>Success</AlertTitle>
        A new execution was started successfully
        <Button onClick={handleViewNewExecution}>View Now</Button>
      </Alert>
      :startExecutionStatus==='FAILED'?
      <Alert severity="error" onClose={onClose}>
        <AlertTitle>Error</AlertTitle>
        An error occurred starting new execution! {startExecutionMessage}
      </Alert>
      :
      <React.Fragment>
        <DialogTitle id="alert-dialog-title">
          Repeat Execution?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="prompt">
            You are about to start a new execution that selects the same inputs as the
            current execution.  
          </DialogContentText>
          {filters>1?
            <FormGroup>
              <FormLabel component="legend">These inputs will be selected</FormLabel>
              {rejected?
              <FormControlLabel
                control={
                  <Checkbox 
                    color="primary"
                    checked={includeResult.rejected} 
                    onChange={handleIncludeResultChange} 
                    name="rejected" />
                }
                label={`${fmtBigInteger(rejected)} rejected input${rejected===1?'':'s'}`}
              />:null}
              {skipped?
              <FormControlLabel
                control={
                  <Checkbox 
                    color="primary"
                    checked={includeResult.skipped} 
                    onChange={handleIncludeResultChange} 
                    name="skipped" />
                }
                label={`${fmtBigInteger(skipped)} skipped input${skipped===1?'':'s'}`}
              />:null}
              {failed?
              <FormControlLabel
                control={
                  <Checkbox 
                    color="primary"
                    checked={includeResult.failed} 
                    onChange={handleIncludeResultChange} 
                    name="failed" />
                }
                label={`${fmtBigInteger(failed)} failed input${failed===1?'':'s'}`}
              />:null}
              {succeeded?
              <FormControlLabel
                control={
                  <Checkbox 
                    color="primary"
                    checked={includeResult.succeeded} 
                    onChange={handleIncludeResultChange} 
                    name="succeeded" />
                }
                label={`${fmtBigInteger(succeeded)} succeeded input${succeeded===1?'':'s'}`}
              />:null}
            </FormGroup>
            :null
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleStartExecution} color="primary" autoFocus>
            Start
          </Button>
        </DialogActions>
      </React.Fragment>
      }
    </Dialog>
  );
}

ExecutionActionRepeat.propTypes = {
  execution: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
};

ExecutionActionRepeat.defaultProps = {
  open: false,
};